import type React from "react";
import { cloneElement, useState } from "react";

import { useTranslation } from "react-i18next";

import { FlagIcon } from "lucide-react";

import { Icon } from "simplydo/react/ui/icon";
import { Modal, ModalContent } from "simplydo/react/ui/modal";

import AfterContentButton from "../SideNav/AfterContentButton";
import ReportContent from "./ReportContent";

type ReportContentChipProps = {
  forType: string;
  forId: string;
  inverted?: boolean;
  trigger?: React.ReactElement<any>;
  style?: React.CSSProperties;
  isCollapsed?: boolean;
};

const ReportContentChip = ({
  forType,
  forId,
  inverted,
  style,
  trigger,
  isCollapsed,
}: ReportContentChipProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <>
      <Modal open={open} onClose={() => setOpen(false)}>
        <ModalContent style={{ marginBottom: 10 }} scrolling>
          <ReportContent
            forType={forType}
            forId={forId}
            reportUrl={window.location.href}
            onComplete={() => setOpen(false)}
          />
        </ModalContent>
      </Modal>
      {trigger ? (
        cloneElement(trigger, { onClick: () => setOpen(true) })
      ) : (
        <AfterContentButton
          onClick={() => setOpen(true)}
          $inverted={inverted}
          style={style}
        >
          <Icon size="small" icon={FlagIcon} />
          {!isCollapsed ? t("report.content.title") : null}
        </AfterContentButton>
      )}
    </>
  );
};

export default ReportContentChip;
